import { Component, OnInit, Input, ViewChild, ChangeDetectorRef, AfterContentChecked, ElementRef } from "@angular/core";
import { CustomerIn } from "src/classes/Customers/CustCard_1";
import { HttpServiceCustomer } from "src/app/services/Customer/http/http.service_Customer";
import { SetValid } from "src/classes/Common/SetValid";
import { Proposal } from "src/classes/Customers/Proposal";
import { Config } from "src/classes/Common/ConfigData";
import { Menu } from "primeng/menu";
import { PopupItem } from "src/classes/Common/PopupItem";
import { DynamicDialogRef, MessageService } from "primeng/api";
import { ExtendedMenuItem } from "src/classes/Common/PrimeNGMenuItem";
import { screenId } from "src/environments/environment";
import { HttpClient, HttpHeaders } from "@angular/common/http";
import { DynamiceditScreenComponent } from "../dynamicedit-screen/dynamicedit-screen.component";
import { DynamicDialogService } from "src/app/services/Customer/dynamic-dialog/dynamic-dialog.service";
import { CustCardTabService } from "src/app/services/Custcard/cust-card-tab/cust-card-tab.service";
import { HostListenerBeforeUnloadDirective } from "src/app/services/Common/host-listener-before-unload.directive";
import { FileExtension } from "src/classes/Customers/FileExtension";
import { NGXLogger } from "ngx-logger";
import { ControlsService } from "src/app/services/Common/controls.service";

type ProposalType = Proposal & { dateProposalText?: string };
type NewFileType = File & { isFileUploaded?: "uploading" | "uploaded" | "sizeError" | "uploadError" };

@Component({
    selector: "app-custcardview45",
    templateUrl: "./custcardview45.component.html",
    styleUrls: ["./custcardview45.component.css"],
    providers: [HttpServiceCustomer, MessageService]
})
export class Custcardview45Component implements OnInit, AfterContentChecked {
    customerin: CustomerIn = new CustomerIn();
    config: Config = new Config();
    receivedvalid: SetValid = new SetValid();

    proposals: ProposalType[];
    state: string = "loading";
    activeProposal: Proposal;

    items: ExtendedMenuItem[];
    attachmentItemsId: number = 2;
    attachmentItems: ExtendedMenuItem[];
    openedMenu: Menu;

    newFiles: NewFileType[] = [];
    fileExtensions: FileExtension[];

    @ViewChild("uploadInput", { static: false }) uploadInput: ElementRef<HTMLInputElement>;

    dynamicDialogRef: DynamicDialogRef;

    previousTab: number = 0;
    saveData: boolean = false;
    componentHasChanged: boolean = false;

    isConfirmDialogVisible: boolean = false;

    isCardMenuOpened: boolean = false;

    messageVisibleTimeout: ReturnType<typeof setTimeout>;
    messageSummary: string;

    @Input() customerId: number = 0;

    @ViewChild("hostListenerBeforeUnload", { static: false }) hostListenerBeforeUnload: HostListenerBeforeUnloadDirective;

    constructor(
        private httpServiceCustomer: HttpServiceCustomer,
        private httpClient: HttpClient,
        private dynamicDialogService: DynamicDialogService,
        private custCardTabService: CustCardTabService,
        private messageService: MessageService,
        private controlsService: ControlsService,
        private changeDetector: ChangeDetectorRef,
        private logger: NGXLogger
    ) {
        custCardTabService.tabChanged.subscribe((tabIndex: number) => this.onTabChange(tabIndex));
    }

    ngOnInit() {
        this.customerin.customer_id = this.customerId;

        // Get proposals
        this.httpServiceCustomer.getProposal(this.customerin)
            .subscribe((data: Proposal[]) => {
                this.proposals = data;

                this.proposals.forEach((element: ProposalType) => {
                    element.dateProposalText = element.dateProposal.split(" ")[0];
                });

                console.log("Count of proposals: " + this.proposals.length);

                if (this.proposals.length == 0) {
                    this.state = "noproposals";
                }
                else {
                    this.state = "loaded";
                }
            }, error => {
                console.log(error);
                this.logger.error("user: " + sessionStorage.getItem("email") + ", component: " + this.constructor.name + ", error: " + error.message);
            });

        // Get business configuration
        this.httpServiceCustomer.getConfig()
            .subscribe((data: Config) => {
                this.config = data;
                console.log("BusinessID:" + this.config.remotebusid);
            }, error => {
                console.log(error);
                this.logger.error("user: " + sessionStorage.getItem("email") + ", component: " + this.constructor.name + ", error: " + error.message);
            });

        // Get the list of items in popup
        this.httpServiceCustomer.getItemsMenuByScreen({ screen_id: screenId.Customers.custcardview }).subscribe(
            (res: [PopupItem]) => {
                let m: ExtendedMenuItem[] = [];
                res.forEach((item: PopupItem) => {
                    const menuItem: ExtendedMenuItem = {
                        label: item.mn_menuitem_title,
                        icon: item.mn_icon.split(".svg")[0],
                        menu_Id: item.mn_menu_id,
                        disabled: item.cb_id_disable != -1 ? this.isDisabled(item.cb_id_disable) : false,
                        command: (event: { item: MouseEvent, originalEvent: MouseEvent }) => this.menuItemCommand(item.mn_order_id, event)
                    };

                    m.push(menuItem);
                });

                this.items = m;
                this.attachmentItems = this.items.filter((item: ExtendedMenuItem) => item.menu_Id == this.attachmentItemsId);
            }, error => {
                console.log(error);
                this.logger.error("user: " + sessionStorage.getItem("email") + ", component: " + this.constructor.name + ", error: " + error.message);
            });

        // Get list of file extensions for proposals
        this.httpServiceCustomer.getFilesExtension()
            .subscribe((data: FileExtension[]) => {
                this.fileExtensions = data;
            }, error => {
                console.log(error);
                this.logger.error("user: " + sessionStorage.getItem("email") + ", component: " + this.constructor.name + ", error: " + error.message);
            });
    }

    ngAfterContentChecked(): void {
        this.changeDetector.detectChanges();
    }

    ngOnDestroy(): void {
        this.custCardTabService.tabIndex = 57;
        this.dynamicDialogService.closeDialog();
        this.saveProposals();
    }

    onTabChange(tabIndex: number): void {
        if (tabIndex == 45) {
            this.saveData = false;
        }

        if (this.previousTab == 45) {
            this.dynamicDialogService.closeDialog();
            this.saveProposals();
        }
        this.previousTab = tabIndex;
    }

    // Hide the menu when scrolling
    onScroll(): void {
        if (this.openedMenu) {
            this.openedMenu.hide();
        }
    }

    getProposalSrc(proposal: ProposalType): string {
        return "https://optimusb12023.s3.eu-north-1.amazonaws.com/" + this.config.remotebusid + "/clients/" + this.customerin.customer_id + "/" + proposal.fileName;
    }

    toggleSubMenu(event: PointerEvent, menu: Menu, proposal: Proposal, isMobile: boolean): void {
        event.stopPropagation();

        if (isMobile) {
            this.isCardMenuOpened = true;
            this.activeProposal = proposal;
        }
        else {
            menu.toggle(event);
            this.activeProposal = proposal;

            if (this.openedMenu && this.openedMenu != menu) {
                this.openedMenu.hide();
            }
            this.openedMenu = menu;
        }
    }

    menuItemCommand(orderId: number, event: { item: MouseEvent, originalEvent: MouseEvent }): void {
        if (event && "originalEvent" in event) {
            event.originalEvent.stopPropagation();
        }

        switch (orderId) {
            case 1: {
                // Edit the comment of the chosen proposal
                this.editComment(this.activeProposal);
                this.isCardMenuOpened = false;
                break;
            }
            case 2: {
                // Download the chosen proposal
                this.downloadFile(this.activeProposal);
                this.isCardMenuOpened = false;
                break;
            }
            case 3: {
                //sharing
                break;
            }
            case 4: {
                // Delete the chosen proposal
                this.isConfirmDialogVisible = true;
                this.isCardMenuOpened = false;
                break;
            }
        }
    }

    editComment(proposal: ProposalType): void {
        (document.activeElement as HTMLElement).blur();
        this.activeProposal = proposal;

        this.dynamicDialogRef = this.dynamicDialogService.openDialog(DynamiceditScreenComponent, {
            data: {
                input_id: 6, value: { proposal, proposalURL: this.getProposalSrc(proposal), proposalMenu: this.attachmentItems.slice(1) },
            },
            header: "ישובים",
            styleClass: "modal modal_purpose_proposal-edit",
            showHeader: false
        });

        this.dynamicDialogRef.onClose.subscribe((receivedObject: any) => {
            this.attachmentItems.find((item: ExtendedMenuItem) => item.label == "מחיקה")
                .command = (event: { item: MouseEvent, originalEvent: MouseEvent }) => this.menuItemCommand(4, event);

            if (receivedObject) {
                if (typeof receivedObject.value == "string") {
                    if (this.activeProposal.comments != receivedObject.value) {
                        this.activeProposal.comments = receivedObject.value;
                    }
                }
                else {
                    this.closeConfirmDialog(true);
                }
            }
        });
    }

    // Deleting proposal function
    async closeConfirmDialog(isAccepted: boolean): Promise<void> {
        if (isAccepted) {
            await this.removeProposalFromAWS(this.activeProposal);

            if (this.proposals.length != 1) {
                this.proposals = this.proposals.filter((proposal: ProposalType) => {
                    return proposal.idProposal != this.activeProposal.idProposal || proposal.fileName != this.activeProposal.fileName;
                });
            }
            else {
                this.proposals[0].lastDeleted = true;
            }

            if (this.proposals.length == 0) {
                this.state = "noproposals";
            }

            this.uploadInput.nativeElement.value = null;

            setTimeout(() => {
                this.saveProposals().then(() => {
                    this.showMessage("success", "מחיקת תמונה בוצעה בהצלחה");
                });
            }, 0);
        }

        this.isConfirmDialogVisible = false;
    }

    async downloadFile(proposal: ProposalType): Promise<void> {
        const response: any = await this.httpClient.post("https://12x2ym9xp9.execute-api.eu-north-1.amazonaws.com/v2/presign-get", {
            businessId: this.config.remotebusid,
            clientId: this.customerin.customer_id,
            fileName: proposal.fileName
        }, {
            headers: new HttpHeaders({
                "Content-Type": "application/json"
            })
        }).toPromise();

        const presignedGetURL: string = JSON.parse(response.body).url;

        this.httpClient.get(presignedGetURL, { responseType: "blob" })
            .subscribe((blob: Blob) => {
                const anchor = document.createElement("a");
                anchor.href = URL.createObjectURL(blob);
                anchor.download = proposal.fileName;

                document.body.appendChild(anchor);
                anchor.click();
                document.body.removeChild(anchor);

                URL.revokeObjectURL(anchor.href);
            });
    }

    uploadDocument(event: Event): void {
        this.newFiles = Array.from((event.currentTarget as HTMLInputElement).files);

        if (this.newFiles.length) {
            this.newFiles.forEach((file: NewFileType) => {
                file.isFileUploaded = "uploading";
            });

            this.dynamicDialogRef = this.dynamicDialogService.openDialog(DynamiceditScreenComponent, {
                data: {
                    input_id: 7, value: {
                        newFiles: this.newFiles,
                        presignedURLdata: {
                            businessId: this.config.remotebusid,
                            clientId: this.customerin.customer_id
                        }
                    },
                },
                header: "ישובים",
                styleClass: "modal modal_purpose_proposal-upload",
                closeOnEscape: false,
                showHeader: false
            });

            this.dynamicDialogRef.onClose.subscribe(() => {
                const newDate: Date | string = new Date();
                const registrationTime: (string | number)[] = [newDate.getHours(), newDate.getMinutes(), newDate.getSeconds()];
                const registrationDate: (string | number)[] = [newDate.getDate(), newDate.getMonth() + 1, newDate.getFullYear()];

                if (+registrationTime[0] < 10) {
                    registrationTime[0] = "0" + registrationTime[0];
                }
                if (+registrationTime[1] < 10) {
                    registrationTime[1] = "0" + registrationTime[1];
                }
                if (+registrationTime[2] < 10) {
                    registrationTime[2] = "0" + registrationTime[2];
                }
                if (+registrationDate[0] < 10) {
                    registrationDate[0] = "0" + registrationDate[0];
                }
                if (+registrationDate[1] < 10) {
                    registrationDate[1] = "0" + registrationDate[1];
                }

                const proposalDate: string = [registrationDate.join("/"), registrationTime.join(":")].join(" ");

                this.newFiles.forEach((file: NewFileType) => {
                    if (file.isFileUploaded == "uploaded") {
                        const fileExtension: FileExtension = this.fileExtensions.find((extension: FileExtension) => extension.extentionName.toLowerCase() == file.name.split(".").pop().toLowerCase());

                        this.proposals.unshift({
                            idProposal: -1,
                            customerId: +this.customerin.customer_id,
                            fileName: file.name,
                            comments: "",
                            dateProposal: proposalDate,
                            dateProposalText: registrationDate.join("/"),
                            isImage: fileExtension ? fileExtension.fileType == 1 : false,
                            isVideo: fileExtension ? fileExtension.fileType == 2 : false
                        })
                    }
                });

                this.proposals = this.proposals.filter((item: ProposalType) => item.lastDeleted != true);
                if (this.proposals.length) {
                    this.state = "loaded";
                }

                this.newFiles = [];

                setTimeout(() => {
                    this.saveProposals();
                }, 0);
            });
        }
    }

    showMessage(severity: string, summary: string): void {
        clearTimeout(this.messageVisibleTimeout);

        if (document.querySelector(".ui-messages") && this.messageSummary != summary) {
            this.messageService.clear();

            this.messageService.add({ severity, summary });
            this.messageSummary = summary;
            this.messageVisibleTimeout = setTimeout(() => {
                this.messageService.clear();
            }, 3500);
        }
        else {
            if (document.querySelector(".ui-messages")) {
                this.messageVisibleTimeout = setTimeout(() => {
                    this.messageService.clear();
                }, 3500);
            }
            else {
                this.messageService.add({ severity, summary });
                this.messageSummary = summary;
                this.messageVisibleTimeout = setTimeout(() => {
                    this.messageService.clear();
                }, 3500);
            }
        }
    }

    saveProposals(): Promise<void> {
        return new Promise((resolve, reject) => {
            if (this.componentHasChanged) {
                this.httpServiceCustomer.setProposal(this.proposals)
                    .then((res: SetValid) => {
                        this.receivedvalid = res;
                        this.receivedvalid.answer = res.answer;
                        console.log("Proposals data saved: " + this.receivedvalid.answer);

                        resolve();

                        this.hostListenerBeforeUnload.resetComponentHasChanged();
                    }, error => {
                        console.log(error);
                        reject();
                        this.logger.error("user: " + sessionStorage.getItem("email") + ", component: " + this.constructor.name + ", error: " + error.message);
                    });
            }
        });
    }

    async removeProposalFromAWS(proposal: Proposal): Promise<any> {
        return this.httpClient.post("https://12x2ym9xp9.execute-api.eu-north-1.amazonaws.com/v2/presign-delete", {
            businessId: this.config.remotebusid,
            clientId: this.customerin.customer_id,
            fileName: proposal.fileName
        }, {
            headers: new HttpHeaders({
                "Content-Type": "application/json"
            })
        }).toPromise();
    }

    // Check if the control with the given id is disabled for the user by his role
    isDisabled(id: number): boolean {
        if (this.controlsService.custcardviewControlsData) {
            let control = this.controlsService.custcardviewControlsData.find(control => control.cb_id == id);
            if (!control) {
                return false;
            }
            let enabledRole = control.cb_is_enabled_role;
            let userRole = sessionStorage.getItem("userRole");
            return +userRole < +enabledRole;
        }
    }
}
